import api from '@/api'
import { sortBy } from 'lodash'

export default {
  namespaced: true,

  state: () => ({
    data: []
  }),

  actions: {
    get: async function (ctx, params) {
      const response = await api.get(`/v1/restaurants`, params)

      ctx.commit('set', response.data)
    }
  },

  mutations: {
    set: function (state, restaurants) {
      const data = restaurants
      state.data = sortBy(data, 'name')
    },

    add: function (state, restaurant) {
      const restaurants = [...state.data]

      restaurants.push(restaurant)

      state.data = sortBy(restaurants, 'name')
    },

    update: function (state, restaurant) {
      const restaurants = [...state.data]

      const restaurantIndex = restaurants.findIndex(u => u._id === restaurant._id)

      if (restaurantIndex >= 0) {
        restaurants[restaurantIndex] = restaurant
      } else {
        restaurants.push(restaurant)
      }

      state.data = sortBy(restaurants, 'name')
    },

    delete: function (state, restaurant) {
      const restaurants = [...state.data]

      const restaurantIndex = restaurants.findIndex(r => r._id === restaurant._id)

      if (restaurantIndex >= 0) {
        restaurants.splice(restaurantIndex, 1)
      }

      state.data = restaurants
    },

    reset: function (state) {
      state.data = []
    }
  }
}
